// #region Imports
import React, { useEffect, useState, useRef, useCallback } from 'react';
import './ClientesCrud-Component.scss';
// #endregion

export default function ClientesCrud({ open = false, cliente = null, onClose = () => {}, onSave = () => {} }) {
	// #region Estado
	const [form, setForm] = useState({
		nome: '',
		cpf: '',
		telefone: '',
		sexo: '',
		data_nascimento: '',
		observacoes: '',
	});
	const overlayRef = useRef(null);
	const firstFieldRef = useRef(null);
	// #endregion

	// #region Efeitos
	useEffect(() => {
		if (cliente) setForm(prev => ({ ...prev, ...cliente }));
		else setForm({ nome: '', cpf: '', telefone: '', sexo: '', data_nascimento: '', observacoes: '' });
	}, [cliente, open]);

	useEffect(() => {
		if (open && firstFieldRef.current) firstFieldRef.current.focus();
	}, [open]);

	const onKeyDown = useCallback((e) => { if (e.key === 'Escape') onClose(); }, [onClose]);
	useEffect(() => {
		if (!open) return;
		window.addEventListener('keydown', onKeyDown);
		return () => window.removeEventListener('keydown', onKeyDown);
	}, [open, onKeyDown]);
	// #endregion

	// #region Early return
	if (!open) return null;
	// #endregion

	// #region Handlers
	function handleChange(e) {
		const { name, value } = e.target;
		setForm(prev => ({ ...prev, [name]: value }));
	}
	function submit(e) {
		e.preventDefault();
		if (!form.nome || form.nome.trim().length < 2) {
			alert('Informe o nome do cliente.');
			if (firstFieldRef.current) firstFieldRef.current.focus();
			return;
		}
		onSave(form);
		onClose();
	}
	function handleOverlay(e) { if (e.target === overlayRef.current) onClose(); }
	// #endregion

	// #region Render
	return (
		<div className="crud-overlay" ref={overlayRef} onMouseDown={handleOverlay} role="dialog" aria-modal="true">
			<div className="crud-modal" role="document">
				<form onSubmit={submit} className="crud-form">
					<h3>{cliente ? 'Editar Cliente' : 'Novo Cliente'}</h3>
					<div className="form-grid">
						<div className="fg-item">
							<label htmlFor="f-nome">Nome *</label>
							<input id="f-nome" name="nome" ref={firstFieldRef} value={form.nome} onChange={handleChange} required />
						</div>
						<div className="fg-item">
							<label htmlFor="f-cpf">CPF</label>
							<input id="f-cpf" name="cpf" value={form.cpf} onChange={handleChange} />
						</div>
						<div className="fg-item">
							<label htmlFor="f-telefone">Telefone</label>
							<input id="f-telefone" name="telefone" value={form.telefone} onChange={handleChange} />
						</div>
						<div className="fg-item">
							<label htmlFor="f-sexo">Sexo</label>
							<select id="f-sexo" name="sexo" value={form.sexo} onChange={handleChange}>
								<option value="">--</option>
								<option value="F">Feminino</option>
								<option value="M">Masculino</option>
							</select>
						</div>
						<div className="fg-item">
							<label htmlFor="f-nasc">Nascimento</label>
							<input id="f-nasc" type="date" name="data_nascimento" value={form.data_nascimento} onChange={handleChange} />
						</div>
						<div className="fg-item fg-span-2">
							<label htmlFor="f-obs">Observações</label>
							<textarea id="f-obs" name="observacoes" value={form.observacoes} onChange={handleChange} />
						</div>
					</div>
					<div className="crud-actions">
						<button type="button" onClick={onClose}>Cancelar</button>
						<button type="submit" className="btn-primary">Salvar</button>
					</div>
				</form>
			</div>
		</div>
	);
	// #endregion
}
